import { ReactNode } from 'react';
import DashboardAdminPageTemplate from 'presentations/views/components/templates/DashboardAdminPageTemplate';
import AccountSettingHeader from 'presentations/views/components/organisms/AccountSettingHeader';
import { spacing, mediaMax, borderRadius } from 'presentations/views/styles';
import HeaderDashboard from 'presentations/views/components/organisms/HeaderDashboard';
import { white } from 'presentations/views/styles/color';
import styled from '@emotion/styled';
import { ViewerItem } from 'presentations/api/schema/user';

interface Props {
  viewer: ViewerItem;
  form: ReactNode;
  currentUrl: string;
  isLoading?: boolean;
}
export default function Component(props: Props) {
  return (
    <DashboardAdminPageTemplate
      isLoading={props.isLoading}
      header={<HeaderDashboard viewer={props.viewer} isAdmin />}
      contentHeader={
        <AccountSettingHeader currentUrl={props.currentUrl} icon="settings" />
      }
      content={<FormContainer>{props.form}</FormContainer>}
    />
  );
}

const FormContainer = styled.div`
  margin: 0 auto ${spacing(48)};
  background: ${white};
  /* width: 960px; */
  padding: ${spacing(48)};
  border-radius: ${borderRadius(16)};
  ${mediaMax.tablet} {
    width: 100%;
    padding: ${spacing(24)};
  }
  ${mediaMax.smartphone} {
    width: 100%;
    padding: ${spacing(20)}};
  }
`;
